import styles from "./form-intro-heading.module.scss";

const FormIntroHeading = ({ lead, emphasis }: { lead: string, emphasis: string }) => {
  return (
    <div className={styles['form-intro-heading']}>
      <span className={styles['form-intro-heading__lead']}>{lead}</span>&ensp;
      <strong className={styles['form-intro-heading__emphasis']}>
        {emphasis}
      </strong>
    </div>
  );
};

export default FormIntroHeading;
